import { ISingleEpletMmRisk } from '../single-eplet-mm-risk';

export interface ICenterChainEndOffer {
    matchHistoryId:number,
    chainId : number,
    clusterNumber : number,
    positionNumber : number,

    donorCenterId: number,
    donorCenter: string,
    donorId: number,
    donorAlias: string,
    donorType: string,
    
    recipientCenterId: number,
    recipientCenter: string,
    recipientId: number,
    recipientAlias: string,
    recipientType : string,

    isAccepted: boolean,

    offerDateTime: string,
    deadlineDateTime: string,
    decisionDateTime: string,

    singleEpletMmRisk: ISingleEpletMmRisk
}